<life-di-nav></life-di-nav>

<div class="container text-center" style="padding-top: 80px;">
    <div class="mx-auto d-block">
        <h1 class="text-center mb-3" style="color: #1C8FC7;">Page not found!</h1>
        <img src="assets/404-error.png" class="img-fluid" alt="" style="width: 300px;">
        <h1 class="text-center mt-4" style="color:#FF7146;">ขออภัย ไม่พบหน้าเว็บไซต์ที่คุณต้องการ</h1>
    </div>
</div>